/*
*  Lookups over the artists (content.js) and artworks (artworks.js)
*/
import { ARDMORE_CATEGORY, ARTISTS } from "./content";
import { ARTIST_ORDER, ARTWORKS } from "./artworks";

const artworksBySlug = new Map(ARTWORKS.map((a) => [a.slug, a]));

//Artists plus Ardmore - everything that has its own shop category
export const CATEGORIES = [...ARTISTS, ARDMORE_CATEGORY];

export const getArtwork = (slug) => artworksBySlug.get(slug);

export const getArtist = (slug) => CATEGORIES.find((c) => c.slug === slug);

export const getCategory = (categorySlug) => CATEGORIES.find((c) => c.category === categorySlug);

//An artist's works, in the order Wix showed them
export const getArtworksBy = (artistSlug) => {
  if (ARTIST_ORDER[artistSlug]) {
    return ARTIST_ORDER[artistSlug].map(getArtwork).filter(Boolean);
  }
  return ARTWORKS.filter((a) => a.artist === artistSlug);
};

export const artworkImage = (image, isSmall = false) => `/images/artworks/${image}${isSmall ? "-sm" : ""}.webp`;
